import webStorageKeys from '@/constants/web-storage-keys';
import { convertCultureToRef } from '@/utils/common-util';
import { BehaviorSubject } from 'rxjs';
import { siteService } from './site.service';
import { ApiSiteNameEnums } from '@nf/types/site';

const profilePanel$ = new BehaviorSubject(false);
const displayProfilePanel = (isShow: boolean, isFromAppBar?: boolean) => {
	profilePanel$.next(isShow);

	const isShowBack = (!isShow || isFromAppBar) ? 'false' : 'true';
	sessionStorage.setItem(webStorageKeys.ME_PAGE_SHOW_BACK, isShowBack);
}

const redirectToDepositUrl = (url: string | undefined) => {
	if (!url) return;
	window.location.href = url;
}

const getRnRUrl = (
	rnrUrl: string | undefined,
	locale: string,
	isDarkMode?: boolean,
	siteId?: string,
	isApp?: boolean
) => {
	if (!rnrUrl) return '';

	let userLang = '';

	if (locale === 'ms-MY') {
		userLang = 'my';
	} else if (locale === 'es-ES') {
		userLang = 'es';
	} else {
		userLang = convertCultureToRef(locale);
	}

	const url = new URL(rnrUrl.replace('{0}', userLang));
	url.protocol = location.protocol;

	url.searchParams.append('new-window', '1'); // 導轉或另開都需要加的參數

	if (isDarkMode) {
		url.searchParams.append('darkmode', '1');
	}

	const isIvory = siteService.isMatchingSite(siteId, ApiSiteNameEnums.N8I);
	if (isIvory && userLang === 'en') {
		url.searchParams.append('isIvory', '1');
	}

	if (isApp) {
		url.searchParams.append('returnUrl', encodeURIComponent(window.location.href));
	}

	return url.href;
}

const getTermAndConditionsUrl = (
	urlTemplate: string | undefined,
	locale: string
) => {
	if (!urlTemplate) return '';

	const localeSegment = convertCultureToRef(locale) === 'id' ? 'id' : 'en';
	const url = new URL(urlTemplate.replace(/\{locale\}/gi, localeSegment));
	url.protocol = location.protocol;

	return url.href;
}

const checkCanBack = () => sessionStorage.getItem(webStorageKeys.ME_PAGE_SHOW_BACK) === 'true';

export const profilePanelService = {
	onProfilePanel$: profilePanel$.asObservable(),
	displayProfilePanel,
	redirectToDepositUrl,
	getRnRUrl,
	getTermAndConditionsUrl,
	checkCanBack
};